import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const RenameIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 18 18" sx={{ height: '18px', width: '18px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M6.75 9.75L11.25 9.75M5.25 12.75L8.45378 5.70168C8.62731 5.31992 8.71407 5.12904 8.8343 5.06982C8.93878 5.01836 9.06122 5.01836 9.1657 5.06982C9.28593 5.12904 9.37269 5.31992 9.54622 5.70168L12.75 12.75M15.75 2.25V15.75M2.25 2.25L2.25 15.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default RenameIcon;
